import { UiTableProps } from "./table.model";

export interface ITableHeaderSearch {
	title?: string;
	tooltip?: string;
	placeholder?: string;
	value?: string | null;
	fn?: (value: string | null | undefined) => void;
	isLoading?: boolean;
	helperText?: string;
}

export class TableHeaderSearch implements ITableHeaderSearch {
	title: string;
	tooltip?: string;
	placeholder: string;
	value?: string | null;
	fn?: (value: string | null | undefined) => void;
	isLoading?: boolean;
	helperText?: string;

	constructor(params: UiTableProps) {
		this.title = params.search?.title ?? "UI_COMPONENTS.TABLE.ACTIONS.SEARCH";
		this.tooltip = params.search?.tooltip;
		this.placeholder =
			params.search?.placeholder ?? "UI_COMPONENTS.TABLE.ACTIONS.SEARCH_PLACEHOLDER";
		this.value = params.search?.value;
		this.fn = params.search?.fn;
		this.isLoading = params.search?.isLoading;
		this.helperText = params.search?.helperText;
	}
}

/**
 * Table search component
 */

export interface UiTableHeaderSearchProps {
	value: string | null;
	placeholder: string;
	searchFn: (value: string | null) => void;
	isLoading?: boolean;
	helperText?: string;
}
